<template>
  <div
    class="overflow-hidden bg-white rounded shadow flex flex-grow flex-col text-gray-800 text-left h-full"
    :class="{ detail: type === 'detail' }"
  >
    <div v-if="imageValue" class="bg-gray-300">
      <img v-lazy="imageValue" class="object-cover h-64 w-full" />
    </div>
    <div class="h-full p-6 flex flex-col justify-between">
      <div>
        <p class="font-semibold text-2xl">{{ title.value }}</p>
        <p class="text-base text-gray-700">{{ description.value }}</p>
      </div>
      <div>
        <a
          v-if="caption.value && caption.type === fieldTypes.URL"
          @click.stop
          :href="caption.value"
          target="_blank"
          class="block mt-4 text-blue-500 hover:text-blue-800"
        >
          Visit
          <vue-fontawesome class="ml-2" icon="external-link-alt" />
        </a>
        <p v-else-if="caption.value" class="mt-4 text-gray-600 text-sm">
          {{ caption.value }}
        </p>
        <a
          v-if="ctaValue"
          @click.stop
          class="block mt-4 bg-blue-500 hover:bg-blue-700 font-medium py-2 px-4 rounded text-center hover:shadow-md transition-shadow duration-300"
          :href="ctaValue"
          :style="{
            'background-color': this.cta.bgColor,
            color: this.cta.color
          }"
          :target="cta.download && cta.value ? '_self' : '_blank'"
        >
          {{ cta.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import FieldTypes from "@/constants/field-types";
import StringUtils from "@/utils/string";

export default {
  name: "BContentCard",

  props: {
    item: {
      type: Object,
      default: () => {}
    },
    config: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: "list",
      validator: val => ["list", "detail"].indexOf(val) > -1
    }
  },

  data() {
    return {
      fieldTypes: FieldTypes
    };
  },

  computed: {
    cta() {
      return {
        text: this.config?.cta?.text || "",
        value: this.item[this.config?.cta?.field?.name] || "",
        bgColor: this.config?.cta?.bgColor || "#3398db",
        color: this.config?.cta?.color || "#ffffff",
        download: this.config?.cta?.download || false
      };
    },
    ctaValue() {
      if (this.cta.download && this.cta.value) {
        return StringUtils.directDownloadLink(this.cta.value) || this.cta.value;
      }
      return this.cta.value;
    },
    title() {
      return {
        value: this.item[this.config?.title?.name] || "",
        type: this.config?.title?.type || ""
      };
    },
    description() {
      return {
        value: this.item[this.config?.description.name] || "",
        type: this.config?.description?.type || ""
      };
    },
    image() {
      return {
        value: this.item[this.config?.image?.name] || "",
        type: this.config?.image?.type || ""
      };
    },
    imageValue() {
      return (
        StringUtils.directDownloadLink(this.image.value) || this.image.value
      );
    },
    caption() {
      return {
        value: this.item[this.config?.caption?.name] || "",
        type: this.config?.caption?.type || ""
      };
    }
  },

  methods: {
    visitLink(link) {
      window.open(link);
    }
  }
};
</script>

<style lang="scss" scoped>
.detail {
  img {
    height: 400px;
  }
}
</style>
